//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
import mixinSolicitudInscripcion from "./MixinSolicitudInscripcion";
//rutas API
var rutaValidarFecha = "/api/Master/Llamada/ValidarFecha";

export default {
  mixins: [mixinSolicitudInscripcion],
  methods: {
    async VerificarFechaEvento(fecha, evento) {
      const _fecha = {
        params: {
          fecha: fecha
        }
      };

      const sendGetRequest = async () => {
        try {
            const resp = await axios.get(rutaValidarFecha, _fecha);
            return resp.data;
        } catch (e) {
            // Handle Error Here
            this.ManejarExcepcion(e);
        }
      };

      let respuesta = await sendGetRequest();
      if (respuesta.estado === 0) {
        if (respuesta.data == 0 || respuesta.data == 1) {
          this.AlertaEmbajadores(servicios.RespuestasValidacionEvento(respuesta.data), true, false);
          respuesta.data = 1;
        } else {
          this.RegistroEvento(evento);
        }
      } else if (respuesta.estado === 1) {
        this.AlertaEmbajadores(respuesta.mensaje, true,false);  
      }
      
      return respuesta;
    }
  }
};
